import gql from "graphql-tag";
const onPublishMessageSub = gql(` 
subscription OnPublishMessage($id: String!) {
  onPublishMessage(id: $id) {
    id
    message
  }
}
`)
export default onPublishMessageSub;